
import { defineComponent } from 'vue';

export default defineComponent({
    components: {
    },
    setup(_, context) {
        const handleConfirm = () => {
            context.emit('confirm', {});
        };
      return {
        handleConfirm
      };
    },
});
